<template>
  <span>
    <b-button variant="info" size="sm" :to="{ name: 'expedition' }">
      <i aria-hidden="true" class="fa fa-shopping-bag"></i>
      Lista de Expedição
    </b-button>
    &nbsp;
    <b-button size="sm" :to="{ name: 'Importacao' }">
      <i aria-hidden="true" class="fa fa-upload"></i>
      Importação
    </b-button>
    &nbsp;
    <b-button size="sm" :to="{ name: 'Exportacoes' }">
      <i aria-hidden="true" class="fa fa-download"></i>
      Exportações
    </b-button>
  </span>
</template>

<script>
export default {
  name: "ScreensMenu",
  props: ["checkFaturador"],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/ActionMenu/ScreensMenu.vue